export enum TStoredValues {
  cashAmount = 'cashAmount',
  creditCardDebt = 'creditCardDebt',
  unsecuredDebt = 'unsecuredDebt',
  isCreditCardDebtChecked = 'isCreditCardDebtChecked',
  isUnsecuredDebtChecked = 'isUnsecuredDebtChecked',
  appliedAmount = 'appliedAmount',
  refinanceableDebts = 'refinanceableDebts',
}
